import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full flex justify-center items-center space-x-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " mediBe Core wird aktualisiert. Bitte haben Sie einen moment Geduld. Die Aktualisierung kann bis zu 5 Minuten dauern. ", -1)

import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import { useSessionStore } from "@/store/sessionStore";
import { encryptSymmetric } from "@/helpers/encryption";
import { ManagedPatient } from "@/interfaces/managedPatient";
import { supabase } from "@/helpers/supabase";
import { bytesToHex, encryptMsg } from "@/helpers/encryption";
import { onMounted } from "vue";
import { usePublicStore } from "@/store/publicStore";
import { useMedicationsStore } from "@/store/medicationsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateView',
  emits: ["updateFinished"],
  setup(__props, { emit: __emit }) {

const managedPatientsStore = useManagedPatientsStore();
const sessionStore = useSessionStore();
const publicStore = usePublicStore();
const medicationsStore = useMedicationsStore();

const emit = __emit;

onMounted(() => {
  executeUpdate().finally(() => {
    emit("updateFinished");
  });
});

async function executeUpdate() {
  // ====================================================================================== Update PatientMedications

  if (managedPatientsStore.patientsMap) {
    for (const patient of managedPatientsStore.patientsMap?.values()) {
      if (patient.currentMedication) {
        const connectedCareProviderGroupIds =
          managedPatientsStore.connectedCareProviderGroups?.get(patient.id);
        if (
          connectedCareProviderGroupIds &&
          connectedCareProviderGroupIds.size > 0
        ) {
          // Convert the Set to an array and access the first element
          const connectedShopCareProviderGroups = Array.from(
            connectedCareProviderGroupIds
          )
            .map((id) => {
              if (publicStore.careProviderGroups) {
                return publicStore.careProviderGroups.find(
                  (cpg) => cpg.id === id
                );
              }
            })
            .filter((cpg) => cpg?.is_shop);
          const firstCpgId = connectedShopCareProviderGroups[0]?.id ?? null;

          for (const medication of patient.currentMedication) {
            medication.supplierId = firstCpgId;
          }
          let error = null;
          do {
            try {
              await medicationsStore.fetchMedicationsInformation(
                patient.currentMedication,
                firstCpgId
              );
              error = null;
            } catch (e) {
              error = e;
            }
          } while (error !== null);
          await encryptAndSaveMedication(patient.currentMedication, patient.id);
        }
      }
    }
  }

  async function encryptAndSaveMedication(
    newMedication: Array<any>,
    patientId: number
  ) {
    const decrypted_symmetric_key =
      managedPatientsStore.keys?.get(patientId)?.decrypted_symmetric_key;

    if (
      !decrypted_symmetric_key ||
      !sessionStore.selectedCareProviderGroup?.id
    ) {
      return;
    } else {
      const encryptedMedication = await encryptSymmetric(
        JSON.stringify(newMedication),
        decrypted_symmetric_key
      );

      let error = null;
      do {
        const res = await supabase
          .from("managedPatient_data")
          .insert({
            managed_patient_id: patientId,
            used_key_id: managedPatientsStore.keys?.get(patientId)?.key_id,
            nonce: encryptedMedication.nonce,
            encrypted_data: encryptedMedication.encryptedMessage,
            owner_care_provider_group_id:
              sessionStore.selectedCareProviderGroup.id,
            type: 2,
          })
          .returns<ManagedPatient[]>();

        if (res.error !== null) {
          error = res.error;
        } else {
          error = null;
        }
      } while (error !== null);

      await managedPatientsStore.updatePatients();
    }
  }

  // ====================================================================================== Update FavoriteMedications

  if (sessionStore.favorites) {
    let cpgId: number | null = null;
    for (const medication of sessionStore.favorites) {
      if (sessionStore.selectedCareProviderGroup?.is_shop) {
        cpgId = sessionStore.selectedCareProviderGroup.id;
        medication.care_provider_group_id = cpgId;
      } else {
        if (
          publicStore.careProviderGroups?.filter((cpg) => cpg.is_shop)[0].id
        ) {
          cpgId = publicStore.careProviderGroups?.filter(
            (cpg) => cpg.is_shop
          )[0].id;
          medication.care_provider_group_id = cpgId;
        }
      }
    }
    let error = null;
    do {
      try {
        await medicationsStore.fetchMedicationsInformation(
          sessionStore.favorites,
          cpgId
        );
        error = null;
      } catch (e) {
        error = e;
      }
    } while (error !== null);
    await saveFavoriteMedications();
  }

  async function saveFavoriteMedications() {
    if (
      sessionStore.selectedCareProviderGroup &&
      sessionStore.selectedCareProviderGroup.id
    ) {
      let encryptedObj = await encryptMsg({
        message: JSON.stringify(sessionStore.favorites),
        serverCareProviderGroupId: sessionStore.selectedCareProviderGroup.id,
        clientCareProviderGroupId: sessionStore.selectedCareProviderGroup.id,
        creatorCareProviderGroupId: sessionStore.selectedCareProviderGroup.id,
      });
      if (encryptedObj.clientKeyId != encryptedObj.serverKeyId) {
        alert("Keys sind nicht synchron. Fehler.");
        return;
      }

      let error = null;
      do {
        const res = await supabase.from("careProviderGroup_favorites").upsert({
          nonce: bytesToHex(encryptedObj.nonce),
          encrypted_favorites: bytesToHex(encryptedObj.encryptedMsg),
          used_key: encryptedObj.clientKeyId,
          care_provider_group_id: sessionStore.selectedCareProviderGroup.id,
        });

        if (res.error !== null) {
          error = res.error;
        } else {
          error = null;
        }
      } while (error !== null);
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingSpinner),
    _hoisted_2
  ]))
}
}

})